module.exports = __webpack_public_path__ + "img/control-variant-placeholder.434c1411.svg";